import request from '@/router/axios'

export function getAskData(obj) {
    return request({
        url: '/api/screen/wenda_data',
        method: 'post',
        data: obj
    })
}

export function getAskDay(obj) {
    return request({
        url: '/api/screen/wenda_data_month',
        method: 'post',
        data: obj
    })
}